import { render } from "./disclaimer.vue?vue&type=template&id=48041f03&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=48041f03&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48041f03"

export default script